export function unpascal(value?: string | undefined) {
  if (value === undefined) {
    return '-'
  }

  const regex = /(?<=[A-Z])(?=[A-Z][a-z])|(?<=[^A-Z])(?=[A-Z])|(?<=[A-Za-z])(?=[^A-Za-z])/g
  const result = value.replace(regex, ' ')
  const lowered = result.toLowerCase()

  return lowered.charAt(0).toUpperCase() + lowered.slice(1)
}

export function unpascalFeeType(value?: string | undefined) {
  if (value === undefined) {
    return '-'
  }

  let newValue = value
  switch (value) {
    case 'RiskControlledPremiumFee': {
      newValue = 'RiskManagedPremiumFee'
      break
    }
    case 'GapProtectionPremium': {
      newValue = 'ProtectionPremium'
      break
    }
    case 'Delta1PremiumFee': {
      newValue = 'DeltaOnePremiumFee'
      break
    }
    case 'OngoingPremium': {
      newValue = 'OngoingNoteFee'
      break
    }
  }

  const regex = /(?<=[A-Z])(?=[A-Z][a-z])|(?<=[^A-Z])(?=[A-Z])|(?<=[A-Za-z])(?=[^A-Za-z])/g
  const result = newValue.replace(regex, ' ')
  const lowered = result.toLowerCase()
  const unpascalResult = lowered.charAt(0).toUpperCase() + lowered.slice(1)

  const arr = unpascalResult.split(' ')
  if (arr.includes('premium') && arr.includes('fee')) {
    arr.splice(arr.indexOf('fee'), 1)
    return arr.join(' ')
  }
  return unpascalResult
}
